import DateTime from '../../modules/components/DateTime';

export default DateTime;



// WEBPACK FOOTER //
// ./src/components/shared/DateTime.js